module.exports = __webpack_public_path__ + "img/category.b52774c7.png";